

<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" fxFlexFill class="congratulations-container">

    <div fxLayout="column">

        <div fxFlex="initial">
            <img style="width: auto; height: 125px;" src="/assets/icons/icon-512x512.png" alt="...">
        </div>

        <div fxFlex="initial">
            <div style="text-align: center;">
                <h2>SUCCESSFULLY SAVED MATCH SCORES</h2>
            </div>
        </div>

        <div fxFlex="initial">
            <div style="text-align: center;">
                <h2>YOUR MATCH IS NOW COMPLETED</h2>
            </div>
        </div>     

        <div fxFlex="initial">
            <div class="court-number" style="text-align: center;">
                <h2>COURT # {{ courtID }}</h2>
            </div>
        </div>          

        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="20px">

            <div fxFlex="initial">
                <button mat-raised-button type="button" [routerLink]="['/director-landing-page']" style="width: 175px">ADMIN LANDING PAGE</button>
            </div>

            <div fxFlex="initial">
                <button mat-raised-button type="button" [routerLink]="['/landing-page']" style="width: 175px"> LANDING PAGE</button>
            </div>     

            <div fxFlex="initial">
                <button mat-raised-button type="button" class="red-button" (click)="getLatestMatchInfo()" style="width: 175px">Get Latest Match Info</button>
            </div>                        

        </div>       

        <div fxFlex style="text-align: center; font-size: 20px;">
            <div style="margin-top: 15px;" >Version  {{ version }}</div>
        </div>                 

    </div>
    
</div>
